<template>
<div class="chapter">
<div class="inner_page">
<p class="line1"><i>To Dawn, with love</i><br/>
<i>in lesser darkness, in greater darkness, in brighter light that follows</i><br/>
<i>ever by my side</i><br/>
<i>ever holding my hand</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedt.vue?7f0f70ee